import React from 'react';
import { Input, Form } from 'semantic-ui-react';
import moment from 'moment';
import DatePicker from 'react-datepicker';

const DateInput = ({ type, value, id, label, onDateChange, language }) => {
  const setDatePickerProps = (type, value, id) => {
    const dateFormat = language === 'en' ? 'L' : 'DD/MM/YYYY';
    const timeFormat = language === 'en' ? 'LT' : 'HH:mm';
    const dateFormatTip = language === 'en' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    const format =
      type === 'date_time' ? `${dateFormat} ${timeFormat}` : dateFormat;
    const setInputValue = e => {
      const { value } = e.target;
      const date = moment(value, format);
      e.target.value = date.format(format);
    };
    const handleChangeRaw = e => {
      const { value } = e.target;
      if (value && !/^(\d\/*)*[ :\d+]*[APM]*$/.test(value)) {
        e.preventDefault();
        return;
      }
      const date = moment(value, format);
      if (!date.isValid()) return;
      onDateChange(date.format('YYYY-MM-DDTHH:mm:ss'), id);
    };
    if (type === 'date_time') {
      return {
        placeholderText: `${dateFormatTip} HH:mm`,
        dateFormat: `${dateFormat} ${timeFormat}`,
        timeFormat: timeFormat,
        selected: moment(value, 'YYYY-MM-DDTHH:mm'),
        onChange: date => onDateChange(date ? date.format() : date, id),
        onChangeRaw: handleChangeRaw,
        showTimeSelect: true,
        onBlur: setInputValue,
        onKeyDown: e => {
          if (e.key !== 'Enter') return;
          setInputValue(e);
        }
      };
    }
    return {
      placeholderText: `${dateFormatTip}`,
      dateFormat: 'DD/MM/YYYY',
      selected: moment(value, 'YYYY/MM/DD'),
      onChange: date =>
        onDateChange(date ? date.format('YYYY-MM-DD') : date, id),
      onChangeRaw: handleChangeRaw,
      onBlur: setInputValue,
      onKeyDown: e => {
        if (e.key !== 'Enter') return;
        setInputValue(e);
      }
    };
  };

  return (
    <DateInputView
      label={label}
      id={id}
      {...setDatePickerProps(type, value, id)}
    />
  );
};

const DateInputView = ({
  label,
  invalidDateFormat,
  errorMessage,
  ...restProps
}) => {
  return (
    <Form>
      {label && <Form.Field>{label}</Form.Field>}
      <DatePicker
        timeIntervals={1}
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false
          }
        }}
        showMonthDropdown
        showYearDropdown
        customInput={<Input style={{ width: '100%' }} />}
        {...restProps}
      />
    </Form>
  );
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/Section/DateInput.js